import { Injectable, Inject } from '@angular/core';
import { Http, Headers, RequestOptions, Response, ResponseContentType } from '@angular/http';
import { APP_CONFIG, AppConfig } from '../config/app.config.module';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/retry';
import { TranslateService, LangChangeEvent } from "@ngx-translate/core";
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { StatisticService } from '../statistic/statistic.service';
import { SharedService} from '../common/shared.service';
import { EventEmitter } from 'protractor';
import { environment } from '../../environments/environment';


/**
 * Author: Sridhar Swaminathan
 * 
 * Date Created: November 14th 2017
 * 
 * Description: Provide service methods to request data related to public data/api.
 **/
@Injectable()
export class PortalService {
  lang = this.lang;
  langId = this.langId;
  loader:boolean = false;
  catData: any;
  allUsersData: any;
  newUsersData: any;
  totalUsers: any;
  totalNewUsers: any;
  getCurrYear = new Date().getFullYear();

  constructor(private sharedService: SharedService, private http: Http, @Inject(APP_CONFIG) private config: AppConfig,  private translate: TranslateService,
  private toastr: ToastrService, private route: ActivatedRoute, private router: Router, private statisticservice: StatisticService) {

    translate.onLangChange.subscribe((event: LangChangeEvent) => {
                  this.loader = true;
                  const myLang = translate.currentLang;

                  if (myLang == 'en') {
                      translate.get('HOME').subscribe((res: any) => {
                          this.lang = 'en';
                          this.langId = 1;
                          this.loader = false;
                      });

                  }
                  if (myLang == 'ms') {
                      translate.get('HOME').subscribe((res: any) => {
                          this.lang = 'ms';
                          this.langId = 2;
                          this.loader = false;
                      });
                  }

              });

              if(!this.langId){
                if(localStorage.getItem('langID')){
                  this.langId = localStorage.getItem('langID');
                }else{
                  this.langId = 1;
                }

              }
  }

  private registerUrl: string = this.config.urlRegister;
  private registerProtectedUrl = this.config.urlProtectedRegister;
  private captchaUrl: string = this.config.urlCaptcha;
  private feedbackUrl: string = this.config.urlFeedback;
  private feedbacktypeUrl: string = this.config.urlFeedbackType;
  private feedbackSettingsUrl: string = this.config.urlFeedbackSettings;
  private profileUrl: string = this.config.urlProfile;
  private fbsubjectUrl: string = this.config.urlFeedbackSubject;
  private usertypeUrl:string = this.config.urlUserType;
  private AgencyAppUrl: string = this.config.urlAppAgency;
  private statusAppUrl: string = this.config.urlAppAgency;
  private dataAppUrl: string = this.config.urlAppAgency;
  private pollUrl: string = this.config.urlPoll;
  private ratingUrl: string = this.config.urlRating;
  private calendarUrl: string = this.config.urlEvents;
  private agencyUrl: string = this.config.urlAgency;
  private digitalServicesUrl: string = this.config.urlDigitalServices;
  private digitalServicesDetailsUrl: string = this.config.urlDigitalServicesDetails;
  private siteMapUrl: string = this.config.urlSiteMap;
  private statisticUrl: string = this.config.urlStatistic;
  private dserviceptUrl: string = this.config.urlDserviceRpt;
  // private trafficUrl: string = this.config.UrlStreetNameAPI;
  // private trafficFlowUrl: string = this.config.UrlTrafficPolylines;
  // private trafficPredictionUrl: string = this.config.UrlTrafficPredictionAPI;

  private internalUrl: string = this.config.urlIntSearch;
  private subStatusUrl: string = this.config.urlSubStatus;

  private portalUrl: string = this.config.urlPortal;
  private protected: string = this.config.urlProtected;
  private dserviceValidationUrl: string = this.config.urlDserviceValidation;
  private dserviceTrackingUrl: string = this.config.urlDserviceTracking;
  private urlSessionHealthy = this.config.urlSessionHealthy;
  private localConfigUrl = this.config.localConfigUrl;

  verifyCaptcha(data) {
    let headers = new Headers({'Content-Type': 'application/json'});
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.captchaUrl+'validateCaptcha', data, options)
    .map((response:Response) => response.json())
    //.retry(5)
    .catch(this.handleError);
  }

  getAgencyApp(){
    return this.http.get(this.AgencyAppUrl + '.json')
        .map(res => res.json());
  }

  getStatusApp(){
    return this.http.get(this.statusAppUrl + '.json')
       .map(res => res.json());
  }

  getDataApp(){
    return this.http.get(this.dataAppUrl + '.json')
       .map(res => res.json());
  }

  // searchApp(){
  //   return this.http.post()
  // }

  create(user) {
    if(!this.langId){
      this.langId = 1;
    }
    return this.http.post(this.registerUrl+"?language="+localStorage.getItem('langID'), user)
      .map((response: Response) => response.json())
      .retry(5)
      .catch(this.handleError);

  }

  addUapUser(user) {
    if(!this.langId){
      this.langId = 1;
    }
    if (!environment.staging) {
      return this.http.post(this.registerProtectedUrl+"?language="+this.langId, user)
      .map((response: Response) => response.json())
      .catch(this.handleErrorProtected);
    } else {
      let headers = new Headers({ 'REMOTE_USER': this.sharedService.getDevUserId() });
      let options = new RequestOptions({ headers: headers });
      return this.http.post(this.registerProtectedUrl+"?language="+this.langId, user, options)
      .map((response: Response) => response.json())
      .catch(this.handleErrorProtected);
    }
   
  }

  createForAgency(user, url) {
    if(!this.langId){
      this.langId = 1;
    }
    return this.http.post(this.registerUrl+"/agency?forward_url="+url+"&language="+localStorage.getItem('langID'), user)
      .map((response: Response) => response.json())
      .retry(5)
      .catch(this.handleError);
  }

  login(name){
    return this.http.get(this.registerUrl+"/?fullName="+name)
      .map((response: Response) => response.json())
      .retry(5)
      .catch(this.handleError);
  }

  feedback(data,lang){
    // let headers = new Headers({ 'Content-Type': 'application/json', 'Accept':'application/json' });
    // let options = new RequestOptions({ headers: headers });
    return this.http.post(this.feedbackUrl + '?language='+lang, data)
      .map((response:Response) => response.json())
      //.retry(5)
      .catch(this.handleError2);
  }

  feedbacksubject(categoryCode, lang){
    return this.http.get(this.fbsubjectUrl + categoryCode+'/subcategory?language='+lang)
      .map((response: Response) => response.json().subcategoryResourceList)
      .catch(this.handleError);
  }

  feedbacktype(lang){
    return this.http.get(this.feedbacktypeUrl + '?language='+lang)
      .map((response: Response ) => response.json().categoryResourceList)
      .catch(this.handleError);
  }

  feedbacksettings(lang){
    return this.http.get(this.feedbackSettingsUrl+ '?language='+lang)
      .map((response: Response ) => response.json())
      .catch(this.handleError);
  }


  createProfile(user) {
    return this.http.post(this.profileUrl, user)
      .map((response: Response) => response.json())
      .retry(5)
      .catch(this.handleError);
  }

  getUserType(data){


    return this.http.get(this.usertypeUrl + data)
    .map((response: Response) => response.json())
    .retry(5)
    .catch(this.handleError);
  }

  // DIGITAL SERVICES
  getDigitalServices(lang) {
    //
    return this.http.get(this.digitalServicesUrl + '?language='+lang)
    .map((response: Response) => response.json())
    .retry(5)
    .catch(this.handleError);
  }

  // SITE MAP
  getSitemapData(lang) {
    //
    return this.http.get(this.siteMapUrl + '?language='+lang)
    .map((response: Response) => response.json())
    .retry(5)
    .catch(this.handleError);
  }

  triggerSiteMap(lang) {

    this.loader = true;
    this.catData = [''];

    return this.route.paramMap
      .switchMap((params: ParamMap) =>
        this.getSitemapData(lang))
      .subscribe(resCatData => {
        this.catData = resCatData;
        this.loader = false;
      });
  }

  // STATISTIC
  getStatisticData(type, year?) {
    
    if (!year) {
      year = this.getCurrYear;
    } else {

    }
    return this.http.get(this.statisticUrl+year+ '&type=' + type)
    .map((response: Response) => response.json())
    .retry(5)
    .catch(this.handleError);
  }

  triggerStatistic(type, year?) {

    this.loader = true;

    return this.route.paramMap
      .switchMap((params: ParamMap) =>
        this.getStatisticData(type, year))
      .subscribe(resStatData => {
        
        if (!resStatData.rows) {
          let rows = [
            ["01","0"],["02","0"],["03","0"],["04","0"],["05","0"],["06","0"],
            ["07","0"],["08","0"],["09","0"],["10","0"],["11","0"],["12","0"]
            ]
          this.allUsersData = ['']; 
          this.newUsersData = [''];
          this.statisticservice.allUser = rows;
          this.statisticservice.newUser = rows;  
          this.totalUsers = 0;
          this.totalNewUsers = 0;
          this.statisticservice.statAllUpdated.emit('Users');
          this.statisticservice.statAllUpdated.emit('newUsers'); 
          this.loader = false;
          return;
        }

        if (type == 1) {
          this.allUsersData = [''];
          this.statisticservice.allUser = resStatData.rows;
          // resStatData.totalsForAllResults['ga:Users'] = parseInt(resStatData.totalsForAllResults['ga:Users'])+1000000; // TESTING PURPOSE ONLY
          this.totalUsers = resStatData.totalsForAllResults['ga:Users'].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          this.statisticservice.statAllUpdated.emit('Users');

        } else if (type == 2) {
          this.newUsersData = [''];
          this.statisticservice.newUser = resStatData.rows;
          // resStatData.totalsForAllResults['ga:newUsers'] = parseInt(resStatData.totalsForAllResults['ga:newUsers'])+1000000;  // TESTING PURPOSE ONLY
          this.totalNewUsers = resStatData.totalsForAllResults['ga:newUsers'].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          this.statisticservice.statAllUpdated.emit('newUsers');
        }

        this.loader = false;
      });
  }

  getCommonDserviceRptData(lng, year) {
    //
    return this.http.get(this.dserviceptUrl+ '/common?year='+ year +'&language=' + lng)
    .map((response: Response) => response.json())
    .retry(5)
    .catch(this.handleError);
  }

  getDserviceRptData(lng, year) {
    //
    return this.http.get(this.dserviceptUrl+ '?year='+ year +'&language=' + lng)
    .map((response: Response) => response.json())
    .catch(this.handleError);
  }

  getPendingDserviceRptData(lng, year) {
    //
    return this.http.get(this.dserviceptUrl+ '/pending?year='+ year +'&language=' + lng)
    .map((response: Response) => response.json())
    .retry(5)
    .catch(this.handleError);
  }

  // CALENDAR
  getCalendarEvents(){

    //
    return this.http.get(this.calendarUrl + '?language='+this.langId)
    .map((response: Response) => response.json())
    .retry(5)
    .catch(this.handleError);
  }

  getCalendarEventsByID(id){


    return this.http.get(this.calendarUrl + '/'+id+'?language='+this.langId)
    .map((response: Response) => response.json())
    .retry(5)
    .catch(this.handleError);
  }

  getCalendarEventsByAgencyID(id){

    //
    return this.http.get(this.calendarUrl + '?agencyId='+id+'&language='+this.langId)
    .map((response: Response) => response.json())
    .retry(5)
    .catch(this.handleError);
  }

  // END CALENDAR

  // AGENCIES DIRECTORY

  // getAgencies(){

  //   //
  //   return this.http.get(this.agencyUrl+localStorage.getItem('langID')+'?keyword='+keyword)
  //   .map((response: Response) => response.json())
  //   .retry(5)
  //   .catch(this.handleError);
  // }

  getAgenciesByKeyword(keyword){

    //
    return this.http.get(this.agencyUrl+this.langId+'?keyword='+keyword)
    .map((response: Response) => response.json())
    .retry(5)
    .catch(this.handleError);
  }

  // getStreetNames(lng){

  //   return this.http.get(this.trafficUrl+"?language="+lng)
  //   .map((response: Response) => response.json())
  //   .retry(5)
  //   .catch(this.handleError);
  // }

  // getTrafficFlows(lng){

  //   return this.http.get(this.trafficFlowUrl+"?language="+lng)
  //   .map((response: Response) => response.json())
  //   .retry(5)
  //   .catch(this.handleError);
  // }

  // getTrafficPrediction(sn,lng){

  //   return this.http.get(this.trafficPredictionUrl+sn+"&language="+lng)
  //   .map((response: Response) => response.json())
  //   .retry(5)
  //   .catch(this.handleError);
  // }

  getSubmissionStatus(refNo, lng) {
    return this.http.get(this.subStatusUrl+"?language="+lng+"&refNo="+ refNo).map((response:Response) => response.json())
    .catch(this.handleError);
  }

  getRelationshipsByLangID(moduleName, lng) {

    return this.http.get(this.config.urlPortal + moduleName + "?language="+lng, '').map((response:Response) => response.json())
    .retry(5)
    .catch(this.handleError);
  }

  // END AGENCIES DIRECTORY

  // NEW

  readPortal(moduleName, page?, size?, keyword?, custom?): Observable<any[]> {
    let readUrl;
    let reqLang = localStorage.getItem('langID');

    if(!keyword && page) {
      //
      readUrl = this.config.urlPortal + moduleName + '?page=' + page + '&size=' + size  + '&language='+this.langId;
    }else if(keyword && custom) {

      readUrl = this.config.urlPortal + moduleName + '?keyword='+keyword+'&page=' + page + '&size=' + size  + '&language='+this.langId+'&'+custom;
    }
    else if(keyword) {
      //
      readUrl = this.config.urlPortal + moduleName + '?keyword='+keyword+'&page=' + page + '&size=' + size  + '&language='+this.langId;
    } else if(custom) {

      readUrl = this.config.urlPortal + moduleName + '?'+custom+ '&language='+this.langId;
    } else {

      readUrl = this.config.urlPortal + moduleName + '?language='+this.langId;
    }


    return this.http.get(readUrl)
      .map((response: Response) => response.json())
      .retry(5)
      .catch(this.handleError);
  }

  readProtected(moduleName, page?, size?, keyword?, custom?): Observable<any[]> {
    let readUrl;
    let reqLang = localStorage.getItem('langID');

    if(!keyword && page) {
      readUrl = this.config.urlProtected + moduleName + '?page=' + page + '&size=' + size  + '&language='+this.langId;
    } else if(keyword) {
      readUrl = this.config.urlProtected + moduleName + '?keyword='+keyword+'&page=' + page + '&size=' + size  + '&language='+this.langId;
    } else if(custom) {
      readUrl = this.config.urlProtected + moduleName + '?'+custom+ '&language='+this.langId;
    } else {
      readUrl = this.config.urlProtected + moduleName + '?language='+this.langId;
    }



    return this.http.get(readUrl)
      .map((response: Response) => response.json())
      .retry(5)
      .catch(this.handleErrorProtected);
  }

  readDServiceProtected(moduleName, page?, size?, keyword?, custom?): Observable<any[]> {
    let readUrl;
    let reqLang = localStorage.getItem('langID');

    if(!keyword && page) {
      readUrl = this.config.urlAgencyDservice + moduleName + '?page=' + page + '&size=' + size  + '&language='+this.langId;
    } else if(keyword) {
      readUrl = this.config.urlAgencyDservice + moduleName + '?keyword='+keyword+'&page=' + page + '&size=' + size  + '&language='+this.langId;
    } else if(custom) {
      readUrl = this.config.urlAgencyDservice + moduleName + '?'+custom+ '&language='+this.langId;
    } else {
      readUrl = this.config.urlAgencyDservice + moduleName + '?language='+this.langId;
    }



    return this.http.get(readUrl)
      .map((response: Response) => response.json())
      .retry(5)
      .catch(this.handleError);
  }

  createDServiceProtected(moduleName, page?, size?, keyword?, custom?): Observable<any[]> {
    let readUrl;
    let reqLang = localStorage.getItem('langID');

    if(!keyword && page) {
      readUrl = this.config.urlAgencyDservice + moduleName + '?page=' + page + '&size=' + size  + '&language='+this.langId;
    } else if(keyword) {
      readUrl = this.config.urlAgencyDservice + moduleName + '?keyword='+keyword+'&page=' + page + '&size=' + size  + '&language='+this.langId;
    } else if(custom) {
      readUrl = this.config.urlAgencyDservice + moduleName + '?'+custom+ '&language='+this.langId;
    } else {
      readUrl = this.config.urlAgencyDservice + moduleName + '?language='+this.langId;
    }


    if(!environment.staging) {
    return this.http.post(readUrl, '')
      .map((response: Response) => response.json())
      .retry(5)
      .catch(this.handleErrorProtected);
    } else {
      let headers = new Headers({ 'REMOTE_USER': this.sharedService.getDevUserId() });
      let options = new RequestOptions({ headers: headers });
      return this.http.post(readUrl, '', options).map((response: Response) => response.json())
        .catch(this.handleErrorProtected);
    }
  }

  readPortalById(moduleName, id): Observable<any[]> {
    let readUrl = this.config.urlPortal + moduleName + id + '?language='+this.langId;

    return this.http.get(readUrl)
      .map((response: Response) => response.json())
      .retry(5)
      .catch(this.handleError);
  }

  readProtectedById(moduleName, id): Observable<any[]> {
    let readUrl = this.config.urlProtected + moduleName + id + '?language='+this.langId;
    return this.http.get(readUrl)
      .map((response: Response) => response.json())
      .retry(5)
      .catch(this.handleErrorProtected);
  }

  removeProtectedById(moduleName, ids): Observable<any[]> {
    let readUrl = this.config.urlProtected + moduleName + ids + '?language='+this.langId;
    return this.http.delete(readUrl)
      .map((response: Response) => response.json())
      .retry(5)
      .catch(this.handleErrorProtected);
  }

// AUTOCOMPLETE


  getAutocompleteList(data){
    return this.http.post(environment.autocompleteURL, data).map((response:Response) => response.json())
    .catch(this.handleError2);
  }

  getAutocompleteByUrl(data, url){
    return this.http.post(url, data).map((response:Response) => response.json())
    .catch(this.handleError2);
  }


// ONLINE SEARCH

  getInternal(data){
    return this.http.post(this.internalUrl, data).map((response:Response) => response.json())
    .retry(5)
    .catch(this.handleError);
  }



// ONLINE SEARCH END

  // create(data, moduleName) {
  //   let createUrl = this.config.urlProtected   + moduleName + '?language='+this.languageId;

  //   return this.http.post(createUrl, data)
  //   .map((response: Response) => response.json())
  //   .catch(this.handleError);
  // }

  // update(data,moduleName) {
  //   let updateUrl = this.config.urlProtected  + moduleName +'?language='+this.languageId;

  //   return this.http.put(updateUrl, data)
  //   .map((response: Response) => response.json())
  //   .catch(this.handleError);
  // }

  // delete(id,moduleName) {
  //   let deleteUrl = this.config.urlProtected  + moduleName + id+ '?language='+this.languageId;
  //

  //   return this.http.delete(deleteUrl, null)
  //   .map((response: Response) => response.json())
  //   .catch(this.handleError);
  // }

  // END NEW

  private handleError(error:any){
      let msg = `Status code ${error.status} on url ${error.url}`;
      console.log(error);
      return Observable.throw(msg);
  }

  private handleError2(error: any){
      return Observable.throw(error);
  }

  public handleErrorProtected = (error: any) => {
   
    if (!error.response && error.status == 0) {
      console.log('cors problem');
      console.log(error);
      this.reloadAfterExpired();
    } else if (error.status && (error.status == 401 || error.status == 0)) {
      console.log('unauthorized');
      console.log(error);
      this.reloadAfterExpired();
    } else {
      console.log(error);
      return Observable.throw(error);
    }
  }

  public reloadAfterExpired = ()=> {

    if (this.sharedService.isAlreadyExpired.getValue() == true) {
      return null;
    }
    this.sharedService.isAlreadyExpired.next(true);
  
    let expiredMsg;
    expiredMsg = this.translate.instant('common.sessionerr');
    setTimeout(()=> {
      this.sharedService.showError(expiredMsg,'', ()=>{ 
        window.location.replace(this.config.urlUAP +'portal/index');
      });
    },400);
    return null;
  }

  errorHandling(err, callback){
    if(err.statusCode){
      let statusCode = err.statusCode.toLowerCase();
      if(statusCode == 'error'){
        this.sharedService.showError(err.statusDesc, 'Error');
      }else{
        callback()
      }
   }else{
     callback()
    }
  }

  private jwt() {
    // create authorization header with jwt token
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser && currentUser.token) {
      let headers = new Headers({ 'Authorization': 'Bearer ' + currentUser.token });
      return new RequestOptions({ headers: headers });
    }
  }

  submitPoll(data) {
    return this.http.post(this.pollUrl, data)
    .map((response: Response) => response.json())
    .retry(5)
    .catch(this.handleError);
  }

  submitScore(data) {
    return this.http.post(this.ratingUrl+"?language="+this.langId, data)
    .map((response: Response) => response.json())
    .retry(5)
    .catch(this.handleError);
  }

  // Dservice validation by DService RefCode
  validateDserviceByRefCode(dsvcCode){

    return this.http
    .get(this.dserviceValidationUrl+dsvcCode)
    .map((response: Response) => response.json())
    .retry(5)
    .catch(this.handleError);
  }

  sendTrackingCount(dserviceCode, agcCode) {

    let body = {
      "agencyCode": agcCode,
      "serviceCode": dserviceCode

    }
    return this.http.post(this.dserviceTrackingUrl+"?language="+localStorage.getItem('langID'), body)
      .map((response: Response) => response.json())
      .retry(5)
      .catch(this.handleError);
  }

  // check session healthy
  getSessionHealthy(lang) {
    //console.log(this.urlSessionHealthy);
    return this.http.get(this.urlSessionHealthy + '?language='+lang)
    //.map((response: Response) => response.json())
    .catch(this.handleError);
  }

  getLocalConfig() {
    return this.http.get(this.localConfigUrl)
    .map((response: Response) => response.json())
    .catch(this.handleError);
  }
  
}



// WEBPACK FOOTER //
// ./src/app/services/portal.service.ts